export default class Category {
    constructor(names,type,brand,level,parentId) {
        this.names = names;
        this.type = type;
        this.brand = brand;
        this.level = level;
        this.parentId = parentId;
    }

    isValid() {
        var result = true;

        for (const [key, value] of Object.entries(this.names)) { if(!value) { result = false; break; }; }
        result = this.type && this.level;

        if(result)
        {
            if(this.type == 'Product')
            {
                result = this.brand;
            }
        }

        return result;
    }
}